var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 22,
    fill: "#77C3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4495 39.2764H32.5506C27.1681 39.2764 22.8047 43.5905 22.8047 48.9123C22.8047 54.2341 27.1681 58.5482 32.5506 58.5482H62.4495C67.832 58.5482 72.1954 54.2341 72.1954 48.9123C72.1954 43.5905 67.832 39.2764 62.4495 39.2764Z",
    fill: "#03121C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4495 37.4521H32.5506C27.1681 37.4521 22.8047 41.7663 22.8047 47.0881C22.8047 52.4099 27.1681 56.724 32.5506 56.724H62.4495C67.832 56.724 72.1954 52.4099 72.1954 47.0881C72.1954 41.7663 67.832 37.4521 62.4495 37.4521Z",
    fill: "#0D5C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1364 55.3919C66.7746 55.3919 70.5346 51.6744 70.5346 47.0885C70.5346 42.5027 66.7746 38.7852 62.1364 38.7852C57.4983 38.7852 53.7383 42.5027 53.7383 47.0885C53.7383 51.6744 57.4983 55.3919 62.1364 55.3919Z",
    fill: "#42A2DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7566 40.0879L57.957 48.3559H62.1645L60.4019 55.0457L67.227 46.4008H63.0743L63.7566 40.0879Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1798 17.7988H20.6719V21.3342H60.1798V17.7988Z",
    fill: "#42A2DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0768 17.7988H70.1914V21.3342H82.0768V17.7988Z",
    fill: "#0D5C9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9873 24.4766H12.9219V27.8766H50.9873V24.4766Z",
    fill: "#42A2DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9507 24.4766H60.2266V27.8766H74.9507V24.4766Z",
    fill: "#42A2DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0264 31.0967H31.9609V34.4967H70.0264V31.0967Z",
    fill: "#0D5C9C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2881 61.2227H23.2227V64.6227H61.2881V61.2227Z",
    fill: "#0D5C9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1483 61.2227H72.1992V64.6227H78.1483V61.2227Z",
    fill: "#0D5C9C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2501 67.834H12.9219V71.234H42.2501V67.834Z",
    fill: "#42A2DA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8931 74.4424H42.25V77.8424H75.8931V74.4424Z",
    fill: "#0D5C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon);
export default __webpack_public_path__ + "static/media/SolutionIcon.3dec01f6c58257da738d6e0db27261f4.svg";
export { ForwardRef as ReactComponent };